module.exports = __webpack_public_path__ + "static/img/jk-doctor.231baac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/jk-doctor.svg
// module id = nwzY
// module chunks = 22